import { useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

/**
 * Reusable reCAPTCHA component
 * @param {function} onChange - Callback when CAPTCHA is completed (receives token)
 * @param {function} onExpired - Callback when CAPTCHA expires (optional)
 * @param {function} onError - Callback on error (optional)
 */
function ReCaptcha({ onChange, onExpired, onError }) {
	const recaptchaRef = useRef(null);
	const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
	const enabled = process.env.REACT_APP_RECAPTCHA_ENABLED === 'true';

	useEffect(() => {
		// Auto-expire and reset after 2 minutes (Google's token expiry time)
		const timer = setTimeout(() => {
			if (recaptchaRef.current) {
				recaptchaRef.current.reset();
				if (onExpired) onExpired();
			}
		}, 120000); // 2 minutes

		return () => clearTimeout(timer);
	}, [onExpired]);

	// If disabled or no site key, render nothing
	if (!enabled || !siteKey) {
		console.warn('[reCAPTCHA] Disabled or site key missing');
		return null;
	}

	const handleChange = (token) => {
		if (onChange) {
			onChange(token);
		}
	};

	const handleExpired = () => {
		if (onChange) {
			onChange(null); // Clear the token
		}
		if (onExpired) {
			onExpired();
		}
	};

	const handleError = (error) => {
		if (onChange) {
			onChange(null); // Clear the token
		}
		if (onError) {
			onError(error);
		}
	};

	return (
		<div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
			<ReCAPTCHA
				ref={recaptchaRef}
				sitekey={siteKey}
				onChange={handleChange}
				onExpired={handleExpired}
				onErrored={handleError}
			/>
		</div>
	);
}

export default ReCaptcha;
